import { serviceDetails, serviceList } from "../data/services";
import { ServiceHero, ProblemSection, SolutionSection, OutcomesSection, ServiceCTA, OtherServices } from "../components/ServiceComponents";
import { useSEO } from "../hooks/useSEO";

export default function ServicePage({ serviceId, onNavigate }) {
  const d = serviceDetails[serviceId];
  const s = serviceList.find(x => x.id === serviceId);

  useSEO({
    title: s ? `${s.title}: Whayns Dijital Hizmetler` : "Hizmet Detayı",
    description: d ? d.heroSubtitle : "",
    path: `/hizmetler/${serviceId}`,
    schema: d ? {
"@context": "https://schema.org",
"@type": "Service",
"name": s?.title,
"description": d.heroSubtitle,
"provider": {
"@type": "Organization",
"name": "Whayns Dijital",
"url": "https://whaynsdijital.com"
      },
"areaServed": { "@type": "Country", "name": "Turkey" },
"url": `https://whaynsdijital.com/hizmetler/${serviceId}`
    } : null,
  });

  if (!d) return null;

  return (
    <div>
      <ServiceHero
        badge={d.badge}
        title={d.heroTitle}
        highlight={d.heroHighlight}
        subtitle={d.heroSubtitle}
      />
      <ProblemSection
        title={d.problemTitle}
        items={d.problems}
      />
      <SolutionSection
        title={d.solutionTitle}
        steps={d.steps}
        note={d.note}
      />
      <OutcomesSection items={d.outcomes} />
      <ServiceCTA onNavigate={onNavigate} />
      <OtherServices currentId={serviceId} onNavigate={onNavigate} />
    </div>
  );
}